
import { Vue, Component } from 'vue-property-decorator'
import { Location, Route } from 'vue-router'

import EventBus from '@/event-bus'
import router from '@/router'

@Component
export default class BookingHeaderTitleMixin extends Vue {
  mounted() {
    const bookingId = router.currentRoute.params.id
    this.setHeaderTitle(bookingId)
  }

  beforeRouteUpdate(to: Route, from: Route, next: (to?: Location) => void) {
    const bookingId = to.params.id
    this.setHeaderTitle(bookingId)
    next()
  }

  beforeDestroy() {
    EventBus.$emit('set-custom-authenticated-header-title', null)
  }

  setHeaderTitle(bookingId: string) {
    const title = `${this.isIslandHopping ? 'Booking' : 'Cruise'} #${bookingId}`
    EventBus.$emit('set-custom-authenticated-header-title', title)
  }
}
